import { Button, Snackbar, SnackbarContent, SnackbarProps } from "@mui/material"
import { Dispatch, SetStateAction } from "react"
import { useKaziNavigate } from "../../../../../Hooks/useKaziNavigate"

interface IProps extends SnackbarProps {
    setOpen: Dispatch<SetStateAction<boolean>>
}

const UpgradeSnackbar = ({ message, autoHideDuration, setOpen, ...props }:IProps) => {
    /* ******************** Hooks ******************** */
    const { navigateToUpgrade } = useKaziNavigate();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleUpgrade = () => {
        navigateToUpgrade();
    }
    const onClose = () =>{
        setOpen(false);
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Snackbar
            {...props}
            autoHideDuration={autoHideDuration ?? 7000}
            onClose={onClose}
            sx={{
                width: '100%', 
                "  > .MuiPaper-root": {
                    backgroundColor: 'warning.main',
                    color: 'primary.main',
                    borderRadius: '8px',
                }
            }}
        >
            <SnackbarContent 
                {...{
                    message
                }}
                action={
                    <Button variant='outlined' onClick={handleUpgrade}>Upgrade</Button>
                }
            />
        </Snackbar>
    )
}

export default UpgradeSnackbar